import React from 'react'
import styles from './BeatLoader.module.scss'
import { Typography } from 'antd'
import { t } from 'i18next'

interface BeatLoaderProps {
  color?: string
  size?: number
  margin?: number
}

const BeatLoader: React.FC<BeatLoaderProps> = ({
  color = "#234bb3",
  size = 15,
  margin = 4,
}) => {
  const style = {
    backgroundColor: color,
    width: `${size}px`,
    height: `${size}px`,
    margin: `${margin}px`,
  }

  return (
    <div className={styles.beatLoader}>
      <div className={styles.beatLoaderChild}>
        <div className={styles.beat} style={style}></div>
        <div className={styles.beat} style={style}></div>
        <div className={styles.beat} style={style}></div>
      </div>
      <Typography.Text className={styles.executing}  >{t('businessCards.running')}</Typography.Text>
    </div>
  )
}

export default BeatLoader
